import { AuthService } from './../../service/auth.service';
import { Component, OnInit,ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.css']
})
export class UserAddComponent implements OnInit {
  useraddForm: FormGroup;
  id: any;
  role: any =  true;
  status: any = true;
  loading:boolean=false;
  load:boolean=false;
  constructor(private form: FormBuilder, private router: Router, private auth: AuthService, private route: ActivatedRoute,public toastr: ToastsManager,vcr: ViewContainerRef ) 
   {
     this.toastr.setRootViewContainerRef(vcr);
    this.route.params.subscribe(params => {
      this.id = params['id']; console.log(this.id);
      if (this.id) {
        this.role = false;
        this.status = false;
        this.auth.getsingleadmin(this.id).then(data => {
          // const admindata = data.valueChanges();
          data.subscribe(singlead => {
            const singleadmin = singlead;
            this.useraddForm.get('name').setValue(singleadmin['name']);
            this.useraddForm.get('username').setValue(singleadmin['username']);
            this.useraddForm.get('email').setValue(singleadmin['email']);
            this.useraddForm.get('name').setValue(singleadmin['name']);
            this.useraddForm.get('role').setValue(singleadmin['role']);
            this.useraddForm.get('status').setValue(singleadmin['status']);
            this.role = true;
            this.status = true;
          });
        });
      }
    });
    }

  ngOnInit() {
    this.useraddForm = this.form.group({
      name: ['', [Validators.required]],
      username: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern('[^ @]*@[^ @]*')]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      role: ['SA', [Validators.required]],
      status: ['InActive', [Validators.required]]
    });
  }

  async  adduser(value, valid) {
        if (valid) {
          this.loading = true;
          this.id ? value['id'] = this.id : '';
          this.auth.signupuser(this.useraddForm.value).then(data => {
            this.router.navigate(['/admin']);
            this.toastr.success('Admin user added!', 'Success!');
          }, error => {
            console.log('error');
            this.toastr.error('Somthing went wrong please try later', 'Oops!');
            this.loading=false;
            this.load=true; 
          });
        } else {
          this.toastr.error('Somthing went wrong please try later', 'Oops!');
          console.log('error');
        }
      }
}



// WEBPACK FOOTER //
// ./src/app/admins/user-add/user-add.component.ts